import React, {Component, Fragment} from 'react';
import { FollowUpListItem } from './FollowUpView';
import { LoadingSpinner } from '../../components/BiopedUI';
import DocumentsSection from './DocumentsSection';
import { UserDetail } from '../../api/services/UserService';
import moment from 'moment';
import { TextArea, FormDataObj, Input } from '../../components/FormUI';
import LookupService from '../../api/services/LookupService';
import Icon from '../../components/Icon';
import FollowUpService from '../../api/services/FollowUpService';
import AccountService from '../../api/services/AccountService';

const contactParse = {email:'email', phone:'homePhone', cell:'cell', work:'workPhone'}
const iconParse = {email:'emailGrey', phone:'phoneGrey', work:'phoneGrey', cell:'textGrey'}

const account = new AccountService();

export default class UserFollowUpView extends Component{
    getViews(){
        let followups = this.props.followup.followup.followup.followups;
        let o = [];
        let user = this.props.followup.user;
        for(let i=0; i < followups.length; i++){
            let fu = followups[i];
            switch(fu.followupType){
                case 'biomechanicalassessment':
                    o.push(<div className='section'>                    
                                <RefProfSection user={user} followup={fu} />
                            </div>)
                break;
                case 'clinic':
                    o.push(<div className='section'>
                                <ClinicSection followup={fu} user={user} />                    
                            </div>)
                break;
                case 'patientemail':
                    o.push(<div className='section'>
                            <ClientSection followup={fu} user={user} />                    
                        </div>)
                break;
            }
        }

        return o;
    }
    getUserDeets(){

        let user = this.props.followup.user;
        let name = user.fullName;
        let icon = iconParse[user.preferredContactMethod];
        let contact = user[contactParse[user.preferredContactMethod]];

        return(<div className='table hmax align-middle'>
            <div>
                <div className='hmax'><div>{name}</div></div>
                <div>{contact}</div>
                <div><Icon icon={icon} /></div>
            </div>
        </div>)
    }
    render(){
        let user = this.props.followup.user;
        let followup = this.props.followup.followup.followup;
        let view = this.getViews();
        console.log("UserFollowUPView FollowUp:", followup);
        return(
            <div className='user-followup-view'>
                <div className='section'>
                    {this.getUserDeets()}
                </div>
                {view}
                <div className='section'>
                    <DocumentsSection followup={followup} />
                </div>
                
            </div>
        )
    }
}

class RefProfSection extends Component{
    state = {};
    form = new FormDataObj();

    handleDownload = ()=>{
        console.log("HAndle Document Download!")
        if(this.state.isBusy)return;
        this.setState({isBusy:true});
        let fu = this.props.followup;
        let opts = {
            FollowupId: fu.clientFollowupId,
            DocumentCategory: 'Letter',
            CoverLetter: this.form.getValue('letter'),
            Comments: this.form.getValue('comments')
        }

        console.log('Document Options! ', opts)

        FollowUpService.SaveDocument(opts, fu.followupType + '-' + moment().format(moment.HTML5_FMT.DATETIME_LOCAL_SECONDS) + '.doc').then(()=>{
            this.setState({isBusy:false});
        })
    }

    render(){
        let df = 'Y-MM-DD';
        let user = this.props.user;
        let followup = this.props.followup;
        let dob = moment(user.birthDate).format(df);
        let assDate = moment(followup.created).format(df);
        let text = `Date ` + moment().format(df) + `

Patient Name: ` + user.fullName + `
Date of Birth: `+ dob + `
Assessment Date: ` + assDate + `

Dear Dr;

Thank you for permitting BioPed Training Centre to share in the care of your patient. The following is a summary of our evaluation.`;

        this.form.setValue('letter', text);

        return(
            <Fragment>
                <h1>Referring Physician</h1>
                <div><UserDetail clientId={user.referringProfessional} detail='fullName'/> </div>
                <TextArea className='taller' form={this.form} name='letter' />
                <h1>Additional Comments</h1>
                <TextArea form={this.form} name='comments' />
                <div alt='Download' className='download-icon' onClick={this.handleDownload}><Icon icon='download'  isBusy={this.state.isBusy} /></div>
            </Fragment>

        )
    }
}

const lookup = new LookupService();
class ClinicSection extends Component{
    form = new FormDataObj();
    state = {};
    handleDownload = ()=>{
        console.log("HAndle Document Download!")
        if(this.state.isBusy)return;
        this.setState({isBusy:true});
        let fu = this.props.followup;
        let opts = {
            FollowupId: fu.clientFollowupId,
            DocumentCategory: 'Letter',
            Diagnosis: this.form.getValue('diagnosis'),
            Comments: this.form.getValue('comments')
        }

        console.log('Document Options! ', opts)

        FollowUpService.SaveDocument(opts, fu.followupType + '-' + moment().format(moment.HTML5_FMT.DATETIME_LOCAL_SECONDS) + '.doc').then(()=>{
            this.setState({isBusy:false});
        })
    }
    componentDidMount(){

    }
    render(){
        return(
            <Fragment>
                <div className='table layout-fixed align-left'>
                    <div>
                        <div><h1>Clinic</h1></div>
                        <div><h1>Insurance</h1></div>
                    </div>
                    <div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
                <h1>Diagnosis</h1>
                <TextArea form={this.form} name='diagnosis' />
                <h1>Additional Comments</h1>
                <TextArea form={this.form} name='comments' />
                <div alt='Download' className='download-icon' onClick={this.handleDownload}><Icon icon='download'  isBusy={this.state.isBusy} /></div>
            </Fragment>
        )
    }
}

class ClientSection extends Component{
    form = new FormDataObj();
    render(){
        let user = this.props.user;
        let text = `Hello ` + user.fullName + `,

Thank you for your recent visit to our clinic. We trust that you will find the attached document(s) helpful. Please feel free to contact us if you have any questions at all or if we can provide some additional assistance.

Yours Truly,
` + account.clinicName ;

        this.form.setValue('text', text);
        return(
            <Fragment>
                <div className='table hmax'>
                    <div>
                        <div><h1>Reminder</h1></div>
                        <div><h1>Requested Documents | Electronic Format</h1></div>
                    </div>
                    <div>
                        <div><Input form={this.form} placeholder='To Email' name='email' /></div>
                        <div></div>
                    </div>
                </div>
                <br/>
                <TextArea className='taller' form={this.form} name='text' />
            </Fragment>
        )
    }
}


// WEBPACK FOOTER //
// ./src/views/followup/UserFollowUpView.js